<template> 
  <div class="menubuilder__form">

    <template v-if="isSending">
    
      <div class="menubuilder__overlay"></div>
      <div class="menubuilder__loader">
        <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
        <div class="">Please Wait...</div>
      </div>    
      
    </template>
    
    
    <h3>A few final details</h3>
    <p>Before we send you your personalised menu, we need a few details.</p>

    <form action="POST">
      <label for="fullName">
        Full Name
        <input type="text" name="fullName" @keyup="validateWhileTyping()" v-model="formData.fullName" id="fullName" placeholder="Full Name" required>
        <span class="menubuilder__form--error" v-if="formErrors.fullName">{{ formErrors.fullName }}</span>
      </label>

      <label for="email">
        Email Address
        <input type="email" name="email" @keyup="validateWhileTyping()" v-model="formData.email" id="email" placeholder="email@gmail.com" required>
        <span class="menubuilder__form--error" v-if="formErrors.email">{{ formErrors.email }}</span>
      </label>

      <label for="company">
        Company Name 
        <input type="text" name="company" @keyup="validateWhileTyping()" v-model="formData.companyName" id="company" placeholder="Company Name">
        <span class="menubuilder__form--error" v-if="formErrors.companyName">{{ formErrors.companyName }}</span>
      </label>

      <label for="postcode">
        Postcode
        <input type="text" name="postcode" @keyup="validateWhileTyping()" v-model="formData.postCode" id="postcode" placeholder="Postcode">
        <span class="menubuilder__form--error" v-if="formErrors.postCode">{{ formErrors.postCode }}</span>
      </label>

      <label for="newsletter">
        <input type="checkbox" name="newsletter" id="newsletter"  v-model="formData.newsletter"> 
        Sign up to marketing communication with Matthew Algie?
      </label>

      <label for="terms">
        <input type="checkbox" name="terms" id="terms" @change="validateWhileTyping()" v-model="formData.terms">
        By using this service, I agree with Matthew Algie's <a href="/terms-conditions" target="_blank">terms and conditions</a>
        and the <a href="/privacy-policy">privacy policy</a>.
        <span class="menubuilder__form--error" v-if="formErrors.terms">{{ formErrors.terms }}</span>
      </label>

      <div class="menubuilder__formbutton">
        <button @click.prevent="$emit('preview')">Preview</button>
        <button @click.prevent="submitForm()" class="menubuilder__formbutton--confirm">Confirm</button>
      </div>
      <div class="menubuilder__messages">
        <p class="menubuilder__errormessage" v-if="errorMessage">{{errorMessage}}</p>
        <p class="menubuilder__successmessage" v-if="successMessage">{{successMessage}}</p>
      </div>
    </form>
    
    
  </div> 
</template>


<script>
  import pdfService from "../../services/pdf.service"
  import axios from 'axios';
  import fonts from "../../fonts/fonts.jspdf"

  export default {
 
    data: function () {  
      return {
        formData: this.$store.state.formData,
        formErrors: this.$store.state.formErrors,
        formHasErrors: false,
        logo: this.$store.state.logo,
        fullState: this.$store.state,
        errorMessage: "",
        successMessage: "",
        isSending: false

      };
    },
    computed: {
    },
    props: [],
    methods: {
      isFieldEmpty(field) {
        return field === "" || field === undefined || field === null || field == false;
      },
      setMessageIfEmpty(field, message) {
        const isValid = this.isFieldEmpty(field) ? message : "";
        this.formHasErrors = this.formHasErrors || !isValid;
        return isValid;
      },
      validateWhileTyping() {
        this.formHasErrors && this.checkForm()
      },
      checkForm() {
        this.formErrors.fullName =    this.setMessageIfEmpty(this.formData.fullName, "The name field is mandatory")
        this.formErrors.email =       this.setMessageIfEmpty(this.formData.email, "The email is mandatory")
        this.formErrors.companyName = this.setMessageIfEmpty(this.formData.companyName, "The company name is mandatory")
        this.formErrors.postCode =    this.setMessageIfEmpty(this.formData.postCode, "The post code is mandatory")
        this.formErrors.terms =       this.setMessageIfEmpty(this.formData.terms, "You must accept the terms and conditions")

        this.formHasErrors = !(this.formErrors.fullName === "" && this.formErrors.email === "" && this.formErrors.companyName === ""
                               && this.formErrors.postCode === "" && this.formErrors.terms === "");

        return !this.formHasErrors;

      },

      async submitForm () {

        if (!this.checkForm()) {
          return;
        }

        this.isSending = true;
        
        this.errorMessage = "";
        this.successMessage = "";

        pdfService.createPDF(this.fullState, false);

        const pdfData = pdfService.downloadAsDataUri();

        const formData = {
          formData: this.formData,
          pdf: pdfData
        };

        try {
          const { data } = await axios.post(`/wp-json/menu/v1/send`, formData );

          console.log({data});
          if(data.success == true) {
            this.successMessage = "Your menu has been generated, please check your emails!";
          } else {
            this.errorMessage = "There was an issue with sending your details, please try again later";
          }
        } 
        catch(e) {
          this.errorMessage = "There was an issue with sending your details, please try again later";
        }

        this.isSending = false;
        
      },

      previewPDF() {
        pdfService.createPDF(this.fullState)
      }
    },
    computed: {
    }, 
    mounted() {
      fonts.addFonts()
    }
  }

</script>


<style lang="sass">
@import "../../../../styles/partials/variables" 

#menubuilder
  
  .menubuilder 
    &__form
      margin-top: 75px
      label
        width: 100%
        margin-bottom: 20px
        font-weight: 400
        input[type=text], input[type=email]
          margin-top: 5px
      button
        font-weight: 600
        border:none!important
        &.menubuilder__formbutton--confirm
          background: $color-green 

      &--error
        color: $color-green
        display: block
        margin-top: 5px
        font-weight: 600

    &__formbutton
      margin-top: 15px
    &__successmessage
      margin-top: 25px;
      font-size: 17px;
      color: #839924;
      font-weight: 600;
    &__errormessage
      margin-top: 25px;
      font-size: 17px;
      color: #839924;
      font-weight: 600;
    &__overlay
      position: fixed
      top: 0
      right: 0
      bottom: 0
      left: 0
      background: rgba($color-black, 0.7)
      z-index: 1000;
    &__loader
      position: fixed
      top: 0
      right: 0
      bottom: 0
      left: 0
      z-index: 1001
      display: flex 
      flex-flow: column
      align-items: center
      justify-content: center
      color: $color-white;
      font-size: 20px;

.lds-ring 
  display: inline-block
  position: relative
  width: 80px
  height: 80px

.lds-ring div 
  box-sizing: border-box
  display: block
  position: absolute
  width: 64px
  height: 64px
  margin: 8px
  border: 8px solid #fff
  border-radius: 50%
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite
  border-color: #fff transparent transparent transparent

.lds-ring div:nth-child(1) 
  animation-delay: -0.45s

.lds-ring div:nth-child(2) 
  animation-delay: -0.3s

.lds-ring div:nth-child(3) 
  animation-delay: -0.15s

@keyframes lds-ring 
  0% 
    transform: rotate(0deg)
  
  100% 
    transform: rotate(360deg)
  


</style>


// WEBPACK FOOTER //
// resources/assets/scripts/vue/components/MenuBuilder/FinalForm.vue